/**
 * Typed provider Stripe billing API facade over the generated contract client.
 */

import * as schemas from '@cnapse/shared/schemas.js';
import { providerStripeApi } from '../api/generated/providerStripe.api.js';
import type { BaseResponse } from '@cnapse/shared/schemas.js';

class ProviderStripeService {
  async assignStripeSubscription(
    data: schemas.AssignStripeSubscriptionRequest,
  ): Promise<schemas.AssignStripeSubscriptionResponse> {
    return providerStripeApi.assignSubscription(data) as Promise<schemas.AssignStripeSubscriptionResponse>;
  }

  async listStripeSubscriptions(
    params?: schemas.ListStripeSubscriptionsRequest,
  ): Promise<schemas.ListStripeSubscriptionsResponse['data']> {
    return providerStripeApi.listSubscriptions(params ?? {}) as Promise<
      schemas.ListStripeSubscriptionsResponse['data']
    >;
  }

  async createStripeProduct(
    data: schemas.CreateStripeProductRequest,
  ): Promise<schemas.SingleStripeProductResponse> {
    return providerStripeApi.createProduct(data) as Promise<schemas.SingleStripeProductResponse>;
  }

  async listStripeProducts(
    request?: schemas.ListStripeProductsRequest,
  ): Promise<schemas.ListStripeProductsResponse> {
    return providerStripeApi.listProducts(request ?? {}) as Promise<schemas.ListStripeProductsResponse>;
  }

  async getStripeProduct(productId: string): Promise<schemas.SingleStripeProductResponse> {
    return providerStripeApi.getProductById(productId) as Promise<schemas.SingleStripeProductResponse>;
  }

  async updateStripeProduct(
    productId: string,
    data: schemas.UpdateStripeProductRequest,
  ): Promise<schemas.SingleStripeProductResponse> {
    return providerStripeApi.updateProduct(productId, data) as Promise<schemas.SingleStripeProductResponse>;
  }

  async archiveStripeProduct(productId: string): Promise<BaseResponse> {
    return providerStripeApi.archiveProduct(productId) as Promise<BaseResponse>;
  }

  async createStripePrice(
    productId: string,
    data: schemas.CreateStripePriceRequest,
  ): Promise<BaseResponse> {
    return providerStripeApi.createPrice(productId, data) as Promise<BaseResponse>;
  }

  async deactivateStripePrice(priceId: string): Promise<BaseResponse> {
    return providerStripeApi.deactivatePrice(priceId) as Promise<BaseResponse>;
  }
}

export const providerStripeService = new ProviderStripeService();
